<template>
  <b-modal
    size="sm"
    hide-footer
    v-model="getShow"
    class="modal"
    centered
  >
    <template v-slot:modal-header="{ cancel }">
      <h5 class="modal-title">{{modalRestoreUser.title}}</h5>
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click.prevent="cancel"
      >
          <span class="material-icons">
            close
          </span>
      </button>
    </template>
    <FormGenerator
      :data="modalRestoreUser.form"
      :isLoading="loading"
      @submit="submit"
    />
  </b-modal>
</template>

<script>
import FormGenerator from '@components/FormGenerator'

export default {
  components: {
    FormGenerator
  },
  props: {
    value: {
      type: Boolean
    },
    loading: {
      type: Boolean
    }
  },
  computed: {
    getShow: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      modalRestoreUser: {
        title: 'User start date',
        form: {
          'date': {
            type: 'datepicker',
            name: 'date',
            label: 'Company start date',
            format: 'dd/MM/yyyy',
            value: null,
            validation: [
              { name: 'required' }
            ],
            class: 'col-12'
          }
        }
      }
    }
  },
  methods: {
    submit (data) {
      this.$emit('submit', data)
    }
  }
}
</script>
